import { Box, Typography } from "@mui/material";
import BAScreenHeader from "../config/components/BAScreenHeader";
import BAButton from "../config/components/BAButton";
import BAGrid from "../config/components/BAGrid";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Delete, Get } from "../config/apimethods/apimethods";
import BAIconbutton from "../config/components/BAIconbutton";
import EditIcon from '@mui/icons-material/Edit';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import PrintIcon from '@mui/icons-material/Print';
import DeleteIcon from '@mui/icons-material/Delete';
import StarRateIcon from '@mui/icons-material/StarRate';
import BAModal from "../config/components/BAModal";
import StarIcon from '@mui/icons-material/Star';

export default function Feedback() {
    const [loader, setLoader] = useState(false)
    const [showMessage, setShowMessage] = useState(false)
    const [message, setMessage] = useState()
    const [listData, setListData] = useState([])
    const [selectedFeedback, setSelectedFeedback] = useState({})
    const [modalProperty, setModalProperty] = useState({
        open: false,
        title: '',
    })

    const navigate = useNavigate()
    const addEdit = (id) => {
    }

    const getData = () => {
        setLoader(true)
        Get('feedback').then(res => {
            setLoader(false)
            if (res.status) {
                setListData(res.data)
            } else {
                setMessage(res.errors)
                setShowMessage(true)
            }
        }).catch(err => {
            setLoader(false)
            console.log(err)
        })
    }
    const delFeedback = (id) => {
        Delete('feedback', id).then(res => {
            setShowMessage(true)
            setMessage("Feedback Deleted Successfully")
            getData()
        }).catch(err => {
            setShowMessage(true)
            setMessage("Feedback Deleted Successfully")
        })
    }

    useEffect(() => {
        getData()
    }, [])


    let printEstimate = (e) => {
        navigate("/printfeedback", { state: { model: e } });
    };
    const handleErrorClose = () => {
        setModalProperty({
            open: false,
            title: 'Feedback',
        })
    }

    return <>
        <BAModal
            modalTitle={modalProperty.title}
            innerContent={<>
                <Box className="p-2">
                    <Typography className="fs-5 fw-bold">Customer</Typography>
                    <Typography>{selectedFeedback.customerName}</Typography>
                </Box>
                <Box className="p-2">
                    <Typography className="fs-5 fw-bold">Comments</Typography>
                    <Typography>{selectedFeedback.comments}</Typography>
                </Box>
                <Box className="p-2">
                    <Typography className="fs-5 fw-bold">Ratings</Typography>
                    <Typography><StarIcon /> {selectedFeedback.starRating}</Typography>
                </Box>
            </>}
            open={modalProperty.open}
            close={handleErrorClose}
        />
        <Box>
            <BAScreenHeader title='Feedback' />
            <Box>
                <BAGrid datasource={listData} gridCols={[
                    {
                        key: 'del',
                        label: 'Delete',
                        className: 'btnCell',
                        displayField: (e) => <BAIconbutton onClick={() => delFeedback(e._id)} color='error' icon={<DeleteIcon />} />
                    },
                    {
                        key: 'view',
                        label: 'View',
                        className: 'btnCell',
                        displayField: (e) => <BAIconbutton onClick={() => {
                            setSelectedFeedback({ ...e })
                            setModalProperty({ open: true, title: 'Feedback' })
                        }} icon={<RemoveRedEyeIcon />} />
                    },
                    {
                        key: 'print',
                        label: 'Print',
                        className: 'btnCell',
                        displayField: (e) => <BAIconbutton onClick={() => printEstimate(e)} icon={<PrintIcon />} />
                    },
                    {
                        key: 'customerName',
                        label: 'Customer Name'
                    },
                    {
                        key: 'starRating',
                        label: 'Rating',
                        displayField: (row) => <Box><StarRateIcon /> {row.starRating} </Box>
                    },
                ]} loading={loader} />
            </Box>
        </Box>
    </>
}